import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ParametrageComponent } from './parametrage.component';

import { Principal } from '../../shared';

@Injectable()
export class ParametrageResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'page,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const parametrageRoute: Routes = [
  {
    path: 'parametrage',
    component: ParametrageComponent,
    resolve: {
      'pagingParams': ParametrageResolvePagingParams
    },
    canActivate: [UserRouteAccessService],
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SYSTEM'],
        pageTitle: 'cadensApp.parametrage.home.title'
    }
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/parametrage/parametrage.route.ts